export default class alertasService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"id": '/api/image/:id'
		};
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId.id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/imageService.js